<template>
    <div class="row mb-2">
        <div class="col-8 fs-20 text-uppercase">Sous-total :</div>
        <div class="col-4 fs-20 text-end" v-text="this.$root.getSubTotal()"></div>
    </div>
    <div class="row mb-2">
        <div class="col-8 fs-20 text-uppercase">Frais de transaction :</div>
        <div class="col-4 fs-20 text-end" v-text="this.$root.getTransactionFees()"></div>
    </div>

    <cart-summary-taxes-component
        v-for="(cartTaxe, name) in this.$root.getTaxes()"
        v-bind:cartTaxe="cartTaxe"
        v-bind:name="name"
    />


    <div class="row mt-5 mb-4 summary-footer-total">
        <div class="col-8 fs-30 fw-bold text-uppercase">Total :</div>
        <div class="col-4 fs-30 fw-bold text-end" v-text="this.$root.getTotal()"></div>
    </div>

    <div class="row">
        <div class="col-12 text-center note">
            Note: Ces montants pourraient être ajustés à la baisse à l'étape du paiement si un rabais est applicable.
        </div>
    </div>

    <div class="row mt-5">
        <div class="col-12">
            <div><h3 class="card-title mb-2">Modalités</h3></div>
            <div>
                <textarea rows="10" class="w-100 p-4" readonly v-bind:value="this.$root.borne_configuration.modalite_paiement"></textarea>
            </div>
        </div>
    </div>
</template>

<script>

import CartSummaryTaxesComponent from "./CartTaxes";

export default {
    name: "CartSummaryComponent",

    components: {
        'cart-summary-taxes-component': CartSummaryTaxesComponent,
    },

    data() {
        return {
            valid_conditions: false,

        }
    },
    created(){
      this.init();
    },

    methods: {
        init()
        {
            this.$root.current_event_is_loaded = this.$root.arrayRemove(this.$root.current_event_is_loaded,'loading-summary');
        },

        valid_modality(event)
        {
          if(this.valid_conditions)
          {
              this.valid_conditions = false;
              this.$root.disabled_next_btn = true;
          }
          else {
              this.valid_conditions = true;
              this.$root.disabled_next_btn = false;
          }
        },


    }
}
</script>

<style scoped>

</style>
